module.exports = __webpack_public_path__ + "static/media/testfile_ssmaskrefinement.774c1825.zip";